import React from 'react'
import CategoryInput from 'sprockets_react/job_wizards/components/CategoryInput'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.Category = React.createClass({
  job: Job,

  getInitialState: function() {
    return this.job.Store.getCategory()
  },

  componentDidMount: function() {
    this.onValidation()
    this.job.Store.addChangeListener(this.updateState)
  },

  componentWillUnmount: function() {
    this.job.Store.removeChangeListener(this.updateState)
  },

  updateState: function(data) {
    this.setState(this.job.Store.getCategory())
  },

  handleSelectedCategory: function( event, selected ) {
    event.preventDefault()
    Job.Actions.updateCategory(selected.item)
    Job.Actions.updateSubCategory(selected.item, 'add')
    Job.Actions.updateKeyword(selected.item.keyword)
    this.validateCategory()
  },

  handleCategoryOnChange: function(event) {
    Job.Actions.updateSubCategory({id: Job.Data.category_id, values: Job.Data.category}, 'remove')
    Job.Actions.updateCategory({ id: 0, value: event.target.value })
    Job.Actions.updateKeyword(null)
  },

  searchTerm: function() {
    if (this.props.emptySearch && this.hasNoSubcategory()) {
      return null
    }

    return this.state.keyword || this.state.category
  },

  hasNoSubcategory: function() {
    return Job.Data.category_id === 0
  },

  onValidation: function() {
    const wizard = JobWizardMobile

    $(() => {
      wizard.Validator.addField('category', {
        verbose: false,
        threshold: 99999,
        validators: {
          callback: {
            callback: (fieldValue, validator) => {
              if (Job.Data.category_id == 0) {
                if (fieldValue !== '' && (this.state.resultCount || 0) == 0) {
                  let linkStr = '<a href="https://www.serviceseeking.com.au/categories" target="_blank">here</a>'
                  let errorMessage = `No matches found for "${fieldValue}". Try using a different term or view all categories ` + linkStr
                    return { valid: false,
                             message: errorMessage }
                } else {
                  return { valid: false,
                  message: 'Please enter your Industry and select the matching one from the drop-down menu' }
                }
              } else {
                return true
              }
            }
          }
        }
      })
    })
  },

  validateCategory: function() {
    let validator = $('#job-modal').data('bootstrapValidator');
    validator.revalidateField('category')
  },

  setSearchResultCount: function(result) {
    this.setState({ resultCount: result.length }, this.validateCategory)
  },

  render: function() {
    return (
      <CategoryInput
        category={this.searchTerm()}
        handleSelectedCategory={this.handleSelectedCategory}
        handleCategoryChange={this.handleCategoryOnChange}
        placeholder={this.props.placeholder}
        preferKeywords="1"
        guId={SS.utils.generateGuid()}
        resultCallback={this.setSearchResultCount}
      />
    )
  }
})
